<template>
  <div class="header">
    <div class="box">
      <div class="icon" @click="goto('/')">
        <img src="@/assets/images/icon.png" alt="" />
      </div>
      <template v-if="path !== '/index/login'">
        <div class="nav">
          <template v-for="item in list">
            <div :key="item.key" @click="goto(item.path)">
              <span :class="{ active: item.path === path }">{{
                item.title
              }}</span>
            </div>
          </template>
        </div>
        <template v-if="$store.getters.isLogin">
          <a-dropdown>
            <div class="avatar">
              <img :src="$store.getters.imgUrl" alt="" />
            </div>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="logout">退出登录</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
        <template v-else>
          <div class="login" @click="goto('/index/login')">登录</div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    path: {
      type: String,
      default: "/",
    },
  },
  data() {
    return {
      list: [
        { key: "home", title: "首页", path: "/" },
        { key: "download", title: "下载", path: "/index/download" },
        { key: "buy", title: "购买", path: "/index/buy" },
        { key: "help", title: "帮助", path: "/index/help" },
      ],
    };
  },
  methods: {
    goto(path) {
      this.$router.push({
        path,
      });
    },
    logout() {
      this.$router.push("/");
      this.$store.commit("CLEAR_USERINFO");
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  width: 100%;
  height: 80px;
  .box {
    max-width: 1200px;
    margin: 0 auto;
    .icon {
      width: 221px;
      height: 37px;
      cursor: pointer;
      float: left;
      margin-top: 21px;
    }
    .nav {
      div {
        width: 136px;
        float: left;
        margin-top: 22px;
        text-align: center;
        span {
          width: 68px;
          height: 36px;
          cursor: pointer;
          text-align: center;
          line-height: 36px;
          display: inline-block;
          font-size: 18px;
          font-weight: 400;
          color: #585f69;
        }
        .active {
          font-weight: bold;
          color: #3370ff;
        }
      }
    }
    .avatar {
      width: 44px;
      height: 44px;
      float: right;
      margin-top: 18px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .login {
      width: 68px;
      height: 36px;
      cursor: pointer;
      float: right;
      margin-top: 21px;
      border-radius: 4px;
      border: 1px solid #3370ff;
      box-sizing: border-box;
      line-height: 34px;
      text-align: center;
      font-size: 18px;
      font-weight: 400;
      color: #3370ff;
      &:hover {
        border: 1px solid #4e83fd;
        color: #4e83fd;
      }
    }
  }
}
</style>
